/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GsnEip712Library,
  GsnEip712LibraryInterface,
} from "../GsnEip712Library";

const _abi = [
  {
    inputs: [],
    name: "EIP712DOMAIN_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GENERIC_PARAMS",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAYDATA_TYPE",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAYDATA_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAY_REQUEST_NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAY_REQUEST_SUFFIX",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAY_REQUEST_TYPE",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAY_REQUEST_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GsnEip712LibraryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GsnEip712LibraryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GsnEip712Library__factory extends ContractFactory {
  constructor(...args: GsnEip712LibraryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<GsnEip712Library> {
    return super.deploy(overrides || {}) as Promise<GsnEip712Library>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GsnEip712Library {
    return super.attach(address) as GsnEip712Library;
  }
  override connect(signer: Signer): GsnEip712Library__factory {
    return super.connect(signer) as GsnEip712Library__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GsnEip712LibraryInterface {
    return new utils.Interface(_abi) as GsnEip712LibraryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GsnEip712Library {
    return new Contract(address, _abi, signerOrProvider) as GsnEip712Library;
  }
}
